/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
  document.querySelectorAll(".buddha-disabled").forEach(function(el) {
  el.addEventListener("click", function() {
    let btn = el.querySelector("button");
    if (btn) {
      // yeh SVG ke parent button ko click karega
      btn.closest("button").click();
    }
  });
});
(function() {


  // Add custom code below this line
$("body").on('click', '.collection__filters__toggle.desktop_filter', function() {
    setTimeout(function() {
        if ($('.collection__filters').hasClass('collection-opened')) {
            $('.collection__filters').removeClass('collection-opened');
            $('body').removeClass('collection-fltr-sct-main');
        } else {
            $('.collection__filters').addClass('collection-opened');
            $('body').addClass('collection-fltr-sct-main');
        }
    }, 100); // Delay in milliseconds (100ms here — adjust if needed)
});

  $("body").on('click', '.filter-header svg', function() {
   $('.collection__filters').removeClass('collection-opened');
 $("body").removeClass('collection-fltr-sct-main');
});

$(document).on('click', '#nav-drawer .select-popout__toggle', function () {
    $('.select-popout__list').toggleClass('select-popout__list--visible select-popout__list--top');
});

document.addEventListener('DOMContentLoaded', function() {
  // Get all li items in nav-drawer
  const navItems = document.querySelectorAll('#nav-drawer li.select-popout__item');
  
  // Add click event listener to each li
  navItems.forEach(item => {
    item.addEventListener('click', function() {
      // Get the data-value of the anchor inside the clicked li
      const selectedValue = this.querySelector('a.select-popout__option').getAttribute('data-value');
      
      // Find and click the matching footer anchor
      const footerAnchor = document.querySelector(`.footer-bottom__content a[data-value="${selectedValue}"]`);
      if (footerAnchor) {
        footerAnchor.click();
      }
    });
  });
});





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


document.addEventListener('DOMContentLoaded', function() {
  let menuList = document.querySelectorAll('.blq-li-list');
  menuList.forEach(function(element) {
    element.addEventListener('click', function() {
      let trigger = element.querySelector('.mobile-nav__trigger');
      if (trigger) {
        trigger.click();
      } else {
        console.log("Trigger not found inside element");
      }
    });
  });

});


